import {
  DOME_SUBTYPE,
  EAR_MOLD_SUBTYPE,
  RECEIVER_SUBTYPE,
  TUBE_SUBTYPE,
} from "constants/products";
import {
  ACCESSORY_PRODUCT_TYPE,
  HEARING_AID_PRODUCT_TYPE,
} from "constants/sales";

import { InventoryProductSpecification } from "services/types/inventory-products.type";
import { InventoryProductSpecificationValues } from "./inventory-product-specification-form.component";
import { merge } from "lodash";
import { EMPTY_HEARING_AID_SPECIFICATION } from "./specification-forms/hearing-aid-specification.component";
import { EMPTY_OTHER_SPECIFICATION } from "./specification-forms/other-specification-form.component";
import { EMPTY_RECEIVER_SPECIFICATION } from "./specification-forms/receiver-specification-form.component";
import { EMPTY_EARMOLD_SPECIFICATION } from "./specification-forms/earmold-specification-form.component";
import { EMPTY_TUBE_SPECIFICATION } from "./specification-forms/tube-specification-form.component";
import { EMPTY_DOME_SPECIFICATION } from "./specification-forms/dome-specification-form.component";
import { InventoryType } from "../inventory-product-form/inventory-product-form.component";

export type ProductForm = {
  isHearingAid?: boolean;
  isReceiver?: boolean;
  isEarmold?: boolean;
  isTube?: boolean;
  isDome?: boolean;
  isOther?: boolean;
};

const EMPTY_VALUES = {
  hearing_aid: null,
  receiver: null,
  earmold: null,
  tube: null,
  dome: null,
  other: null,
};

export const getProductSpecificationType = (
  type: number | string,
  subtype?: number | string | null
): ProductForm => {
  if (Number(type) === HEARING_AID_PRODUCT_TYPE) {
    return {
      isHearingAid: true,
    };
  } else if (
    Number(type) === ACCESSORY_PRODUCT_TYPE &&
    Number(subtype) === RECEIVER_SUBTYPE
  ) {
    return {
      isReceiver: true,
    };
  } else if (
    Number(type) === ACCESSORY_PRODUCT_TYPE &&
    Number(subtype) === EAR_MOLD_SUBTYPE
  ) {
    return {
      isEarmold: true,
    };
  } else if (
    Number(type) === ACCESSORY_PRODUCT_TYPE &&
    Number(subtype) === TUBE_SUBTYPE
  ) {
    return {
      isTube: true,
    };
  } else if (
    Number(type) === ACCESSORY_PRODUCT_TYPE &&
    Number(subtype) === DOME_SUBTYPE
  ) {
    return {
      isDome: true,
    };
  } else if (Number(type) === ACCESSORY_PRODUCT_TYPE) {
    return {
      isOther: true,
    };
  }

  return {};
};

export const getDefaultValues = (
  { isHearingAid, isReceiver, isEarmold, isTube, isDome, isOther }: ProductForm,
  initialValues?: InventoryProductSpecification | null
): InventoryProductSpecificationValues => {
  if (isHearingAid) {
    return merge({}, EMPTY_VALUES, {
      hearing_aid: initialValues ?? EMPTY_HEARING_AID_SPECIFICATION,
    });
  } else if (isReceiver) {
    return merge({}, EMPTY_VALUES, {
      receiver: initialValues ?? EMPTY_RECEIVER_SPECIFICATION,
    });
  } else if (isEarmold) {
    return merge({}, EMPTY_VALUES, {
      earmold: initialValues ?? EMPTY_EARMOLD_SPECIFICATION,
    });
  } else if (isTube) {
    return merge({}, EMPTY_VALUES, {
      tube: initialValues ?? EMPTY_TUBE_SPECIFICATION,
    });
  } else if (isDome) {
    return merge({}, EMPTY_VALUES, {
      dome: initialValues ?? EMPTY_DOME_SPECIFICATION,
    });
  } else if (isOther) {
    return merge({}, EMPTY_VALUES, {
      other: initialValues ?? EMPTY_OTHER_SPECIFICATION,
    });
  }
  return merge({}, EMPTY_VALUES);
};

export const mapValuesToSpecification = (
  {
    hearing_aid,
    receiver,
    earmold,
    tube,
    dome,
    other,
  }: InventoryProductSpecificationValues,
  inventoryType: InventoryType
): InventoryProductSpecification => {
  if (hearing_aid) {
    return {
      battery: hearing_aid?.battery ?? "",
      color: hearing_aid?.color,
      manufacturer_instruction: hearing_aid?.manufacturer_instruction ?? "",
      additional_notes: hearing_aid.additional_notes,
    };
  } else if (receiver) {
    return {
      gain: receiver?.gain,
      length: Number(receiver?.length),
      additional_notes: receiver.additional_notes,
    };
  } else if (earmold) {
    return {
      ear: (earmold?.ear ?? "") as any,
      canal_length: earmold?.canal_length ?? "",
      venting: earmold?.venting ?? "",
      material: earmold?.material ?? "",
      options: earmold?.options,
      additional_notes: earmold?.additional_notes,
    };
  } else if (tube) {
    if (inventoryType === "clinicStock") {
      return {
        size: tube?.size ?? "",
        additional_notes: tube.additional_notes,
      };
    }

    return {
      additional_notes: tube.additional_notes,
    };
  } else if (dome) {
    if (inventoryType === "clinicStock") {
      return {
        size: dome?.size ?? "",
        type: dome?.type ?? "",
        additional_notes: dome.additional_notes,
      };
    }

    return {
      additional_notes: dome.additional_notes,
    };
  } else if (other) {
    return {
      additional_notes: other.additional_notes,
    };
  }
};
